export default function StatistikCard({
  titel,
  wert,
  einheit = '',
  icon: Icon,
  farbe = 'blue',
  trend = null
}) {
  const farbKlassen = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    red: 'bg-red-100 text-red-600',
    purple: 'bg-purple-100 text-purple-600',
    teal: 'bg-primary-light text-primary'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-600 mb-1">{titel}</p>
          <p className="text-3xl font-bold text-gray-900">
            {typeof wert === 'number' ? wert.toLocaleString('de-DE') : wert}
            {einheit && <span className="text-lg ml-1">{einheit}</span>}
          </p>
          {trend !== null && (
            <p className={`text-sm mt-2 ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend).toFixed(1)}% zum Vormonat
            </p>
          )}
        </div>
        {Icon && (
          <div className={`p-4 rounded-xl ${farbKlassen[farbe]}`}>
            <Icon className="w-8 h-8" />
          </div>
        )}
      </div>
    </div>
  );
}
